import React, { useState, useEffect } from 'react';
import { Plus, Save, Trash2, Edit } from 'lucide-react';
import api from '../services/api';

export default function CategoriesConfig({ tenantId }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingCategory, setEditingCategory] = useState(null);

  const defaultCategory = {
    name: '',
    annualQuota: 18,
    maxCarryOver: 0
  };

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/tenants/${tenantId}/admin/categories`);
      setCategories(res.data.data);
    } catch (err) {
      alert('Failed to load categories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [tenantId]);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editingCategory.id) {
        // Assume PUT if implemented, otherwise POST for now
        // Currently admin.js doesn't have PUT for categories, only POST. We'll just POST for now
        await api.post(`/tenants/${tenantId}/admin/categories`, editingCategory);
      } else {
        await api.post(`/tenants/${tenantId}/admin/categories`, editingCategory);
      }
      setEditingCategory(null);
      fetchCategories();
    } catch (err) {
      alert('Save failed: ' + (err.response?.data?.error?.message || err.message));
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h3 style={{ margin: 0 }}>Employee Categories</h3>
        <button className="btn btn-outline" onClick={() => setEditingCategory(defaultCategory)}>
          <Plus size={16} /> New Category
        </button>
      </div>

      {editingCategory && (
        <form onSubmit={handleSave} style={{ background: 'var(--bg-secondary)', padding: '24px', borderRadius: '8px', marginBottom: '24px' }}>
          <h4 style={{ marginBottom: '16px' }}>{editingCategory.id ? 'Edit Category' : 'Create New Category'}</h4>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div className="form-group">
              <label className="form-label">Category Name</label>
              <input type="text" className="form-input" required value={editingCategory.name} onChange={e => setEditingCategory({...editingCategory, name: e.target.value})} placeholder="e.g. Manager, Senior Staff" />
            </div>

            <div className="form-group">
              <label className="form-label">Annual Quota (Days)</label>
              <input type="number" className="form-input" required min="18" value={editingCategory.annualQuota} onChange={e => setEditingCategory({...editingCategory, annualQuota: e.target.value})} />
            </div>

            <div className="form-group">
              <label className="form-label">Max Carry Over</label>
              <input type="number" className="form-input" required min="0" value={editingCategory.maxCarryOver} onChange={e => setEditingCategory({...editingCategory, maxCarryOver: e.target.value})} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '12px', marginTop: '24px', justifyContent: 'flex-end' }}>
            <button type="button" className="btn btn-outline" onClick={() => setEditingCategory(null)}>Cancel</button>
            <button type="submit" className="btn btn-primary"><Save size={16} /> Save</button>
          </div>
        </form>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border-color)', textAlign: 'left', color: 'var(--text-muted)' }}>
              <th style={{ padding: '12px' }}>Name</th>
              <th style={{ padding: '12px' }}>Annual Quota</th>
              <th style={{ padding: '12px' }}>Max Carry Over</th>
            </tr>
          </thead>
          <tbody>
            {categories.map(cat => (
              <tr key={cat.id} style={{ borderBottom: '1px solid var(--border-color)' }}>
                <td style={{ padding: '12px', fontWeight: 500 }}>{cat.name}</td>
                <td style={{ padding: '12px' }}>{cat.annualQuota} days</td>
                <td style={{ padding: '12px' }}>{cat.maxCarryOver} days</td>
              </tr>
            ))}
            {categories.length === 0 && (
              <tr><td colSpan="3" style={{ padding: '16px', textAlign: 'center', color: 'var(--text-muted)' }}>No categories found.</td></tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
